// extracted by mini-css-extract-plugin
export default {"wrapper":"XfaTemplateContainer_wrapper__5LQWT","rootWrapper":"XfaTemplateContainer_rootWrapper__MB1UG"};